import {
  AfterViewInit,
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  DestroyRef,
  inject,
  Input,
  QueryList,
} from '@angular/core';

import { ExpansionDirective } from './expansion.directive';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-accordion',
  imports: [],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent implements AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  @Input({ transform: booleanAttribute })
  multi = false;

  @ContentChildren(ExpansionDirective)
  details!: QueryList<ExpansionDirective>;

  ngAfterViewInit() {
    if (this.multi) {
      return;
    }

    this.details.forEach((targetDetail) => {
      targetDetail.isOpenChange
        .pipe(
          filter((v) => v),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe(() => {
          this.details.forEach((detail) => {
            if (detail !== targetDetail) {
              detail.isOpen = false;
            }
          });
        });
    });
  }
}
